import { render, staticRenderFns } from "./JPOBannier.vue?vue&type=template&id=0740f699"
import script from "./JPOBannier.vue?vue&type=script&lang=js"
export * from "./JPOBannier.vue?vue&type=script&lang=js"
import style0 from "./JPOBannier.vue?vue&type=style&index=0&id=0740f699&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports